/**
 * Gets the pixels within the circle.
 * @export @public @method
 * @name getCircle
 *
 * @param  {number} radius     The radius of the circle.
 * @param  {number} rows       The number of rows.
 * @param  {number} columns    The number of columns.
 * @param  {number} [xCoord = 0] The x-location of the center of the circle.
 * @param  {number} [yCoord = 0] The y-location of the center of the circle.
 * @param  {number} scale Thickness of the image.
 * @returns {Array.number[]}        Array of pixels contained within the circle.
 */
export default function getCircle(
  radius,
  rows,
  columns,
  xCoord = 0, // NOSONAR
  yCoord = 0, // NOSONAR
  scale
) {
  const x0 = xCoord;
  const y0 = yCoord;

  if (radius === 1) {
    return [[Math.floor(x0), Math.floor(y0)]];
  }

  const circleArray = [];
  let index = 0;

  const rowRadius = rows < columns ? radius * scale : radius;
  const columnRadius = columns < rows ? radius * scale : radius;

  for (let y = -rowRadius; y <= rowRadius; y++) {
    const yCoord = Math.floor(y0 + y); // NOSONAR

    if (yCoord > rows || yCoord < 0) {
      continue;
    }

    for (let x = -columnRadius; x <= columnRadius; x++) {
      const xCoord = Math.floor(x0 + x); // NOSONAR

      if (xCoord >= columns || xCoord < 0) {
        continue;
      }

      if (
        (x * x) / (columnRadius * columnRadius) +
          (y * y) / (rowRadius * rowRadius) <=
        1
      ) {
        circleArray[index++] = [xCoord, yCoord];
      }
    }
  }

  return circleArray;
}
